import school from '@/views/year2020/landingPage/school-channel'
export default [
    {
        path: '/school',
        name: 'SchoolChannel',
        component: school,
        description: '校渠'
    },
    {
        path: '/picture-book',
        name: 'picture-book',
        component: school,
        description: '校渠绘本、书签'
    },
    {
        path: '/poster',
        name: 'poster',
        component: school,
        description: '校渠海报'
    }
]
